// The Unicode controls that reorder the text around them: the embeddings
// and overrides (U+202A–U+202E), the isolates (U+2066–U+2069) and the marks
// (U+200E, U+200F, U+061C). English research has no use for them, and one
// override (U+202E) at the end of a link's text reverses everything after
// it on screen — the host shown beside the link included, so "moc.tf"
// reads "ft.com" (projects/investing D8, PR 3 review). The investing API
// refuses the same set on write (backend/investing/constants.py,
// BIDI_CONTROL_RE — its test_constants.py reads this line): change both in
// one PR.
const BIDI_CONTROLS = /[\u061C\u200E\u200F\u202A-\u202E\u2066-\u2069]/g;

/**
 * Untrusted text without its bidi controls. Not a string (null, a number)
 * comes back as it was.
 */
export function withoutBidiControls(text) {
  return typeof text === "string" ? text.replace(BIDI_CONTROLS, "") : text;
}
